export const environment = {
  production: false,
  appName: 'Jadhu Health',
  websiteUrl: 'https://jadhuhealth.com',

};
